import type { QuizAnswers } from '@volt/shared';

const PREFIX = 'volt.quiz.';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

function defaultStorage(): StorageLike | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null; // storage can be blocked (private mode, embedded browsers)
  }
}

/** Answers the user already sent for a quiz message, or null if it was never answered. */
export function loadQuizAnswers(
  messageId: string,
  storage: StorageLike | null = defaultStorage(),
): QuizAnswers | null {
  try {
    const raw = storage?.getItem(PREFIX + messageId);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
    const answers: QuizAnswers = {};
    for (const [id, value] of Object.entries(parsed)) {
      if (Array.isArray(value) && value.every((item) => typeof item === 'string')) answers[id] = value;
    }
    return answers;
  } catch {
    return null;
  }
}

export function saveQuizAnswers(
  messageId: string,
  answers: QuizAnswers,
  storage: StorageLike | null = defaultStorage(),
): void {
  try {
    storage?.setItem(PREFIX + messageId, JSON.stringify(answers));
  } catch {
    /* losing the "already answered" mark only re-enables the card on this device */
  }
}
